import type { paths } from '@orlikfy/api-interfaces';

export type {
  CreateManyGameInvitationsDto,
  GameInvitationCandidate,
  GameInvitationCandidatesDto
} from '@orlikfy/api-interfaces';

// GET /hosted-games/{hostedGameId}/invitations/candidates
export const GET_GAME_INVITATION_CANDIDATES_PATH =
  '/hosted-games/{hostedGameId}/invitations/candidates' as const satisfies keyof paths;
type GetGameInvitationCandidatesOperation = paths[typeof GET_GAME_INVITATION_CANDIDATES_PATH]['get'];
export type GetGameInvitationCandidatesPathParams = GetGameInvitationCandidatesOperation['parameters']['path'];
export type GetGameInvitationCandidatesResponse =
  GetGameInvitationCandidatesOperation['responses'][200]['content']['application/json'];

// POST /hosted-games/{hostedGameId}/invitations
export const SEND_GAME_INVITATIONS_PATH = '/hosted-games/{hostedGameId}/invitations' as const satisfies keyof paths;
type SendGameInvitationsOperation = paths[typeof SEND_GAME_INVITATIONS_PATH]['post'];
export type SendGameInvitationsPathParams = SendGameInvitationsOperation['parameters']['path'];
export type SendGameInvitationsBody = SendGameInvitationsOperation['requestBody']['content']['application/json'];
export type SendGameInvitationsResponse = SendGameInvitationsOperation['responses'][200]['content']['application/json'];

// DELETE /game-invitations/{invitationId}/reject
export const REJECT_GAME_INVITATION_PATH = '/game-invitations/{invitationId}/reject' as const satisfies keyof paths;
type RejectGameInvitationOperation = paths[typeof REJECT_GAME_INVITATION_PATH]['delete'];
export type RejectGameInvitationPathParams = RejectGameInvitationOperation['parameters']['path'];
